export default __webpack_public_path__ + "static/media/index_file.c05fcf3b.svg";